module.exports = __webpack_public_path__ + "static/img/join_6.9a921c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_6.jpg
// module id = L665
// module chunks = 1